import {
  fetchGetApiIntroducerPortalIntroducerBranches,
  GetApiIntroducerPortalIntroducerBranchesResponse,
} from '@iwoca/lapi-client/introducer_portal';
import { lendingApiFetchJson } from 'lendingApi/lendingApi';
import { URLS } from 'utils/tests/urls.config';
import {
  TBranch,
  TSubmitRegistrationParams,
  TTitle,
} from '../registration.types';

export const getAvailableBranches = async ({
  headquarters,
}: {
  headquarters: string;
}): Promise<TBranch[]> => {
  const response = await fetchGetApiIntroducerPortalIntroducerBranches({
    query: { headquarters },
  });

  return (
    response.data as GetApiIntroducerPortalIntroducerBranchesResponse['data']
  )
    .map((branch) => ({
      uuid: branch.uuid,
      name: branch.branch_name,
      number: branch.branch_number,
    }))
    .sort((a: TBranch, b: TBranch) =>
      a.name.localeCompare(b.name, 'de-DE', { sensitivity: 'base' }),
    );
};

export const submitDERegistration = async ({
  values,
  onSuccess,
  onError,
}: TSubmitRegistrationParams) => {
  const introducerValues = {
    // Fixes type error as values.title can be 'herr' | 'frau' whereas lapi client types expect UK values only
    title: values.title as TTitle,
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    phone_number: values.phoneNumber,
  };

  try {
    if (values.uuid) {
      // Using lendingApiFetchJson as we need to send the FE tokens due to the user not being logged in
      await lendingApiFetchJson(URLS.postIntroducer(), {
        method: 'post',
        body: JSON.stringify({
          data: { ...introducerValues, introducer_company_id: values.uuid },
        }),
      });
    } else {
      await lendingApiFetchJson(URLS.postIntroducerAccount(), {
        method: 'post',
        body: JSON.stringify({
          data: {
            introducer_account: {
              introducer_type: values.introducerType,
              public_facing_company_name: values.companyTradingName,
              address: values.registeredTradingAddress,
              company_name: values.companyName,
              company_number: values.companyNumber,
              email: values.email,
              fca_reference: values.FCAReferenceNumber,
              phone_number: values.phoneNumber,
              post_code: values.postcode,
              vat_number: values.vatNumber,
              website: values.companyWebsite,
            },
            introducer: {
              ...introducerValues,
            },
          },
        }),
      });
    }
    await onSuccess();
    return;
  } catch {
    onError();
  }
};
